'use client';

import { Box, Flex } from '@skin-seoul/design-system';
import { Carousel } from '@/components/ui/Carousel';
import { useSafeRouter } from '@/hooks/useSafeRouter';
import BannerMedia from './BannerMedia';
import { useRef } from 'react';
import { createBannerAutoplayPlugin } from '../utils/bannerCarouselConfig';
import { useBannerService } from '@skin-seoul/service';
const SliderDot = ({
  isSelected,
  onClick
}: {
  isSelected: boolean;
  onClick: () => void;
}) => {
  return <Box as="button" onClick={onClick} width="8px" height="8px" borderRadius="4px" backgroundColor={isSelected ? 'neutral.500' : 'generic.0'} margin={0} transition="background-color 0.3s" cursor="pointer" border="none" padding={0} data-sentry-element="Box" data-sentry-component="SliderDot" data-sentry-source-file="BannerList.tsx" />;
};
const BannerList = () => {
  const {
    push
  } = useSafeRouter();
  const {
    useGetBannersSuspenseQuery
  } = useBannerService();
  const {
    data
  } = useGetBannersSuspenseQuery({
    location: '/',
    active: true
  });
  const sortedBanners = data.banners.sort((a, b) => a.order - b.order) || [];
  const autoplayPlugin = useRef(createBannerAutoplayPlugin());
  if (sortedBanners.length === 0) {
    return null;
  }
  return <Carousel opts={{
    loop: true,
    align: 'center'
  }} style={{
    height: '100%'
  }} plugins={[autoplayPlugin.current]} data-sentry-element="Carousel" data-sentry-component="BannerList" data-sentry-source-file="BannerList.tsx">
      <Carousel.Content style={{
      height: '100%'
    }} data-sentry-element="Carousel.Content" data-sentry-source-file="BannerList.tsx">
        {sortedBanners.map((banner, index) => <Carousel.Item key={banner.bannerId} onClick={() => push(banner.linkUrl)} style={{
        paddingLeft: '0',
        height: '100%'
      }} cursor="pointer">
            <BannerMedia display={{
          base: 'none',
          tablet: 'block'
        }} src={banner.imageUrl} alt={banner.title} width={1280} height={600} priority={index === 0} />
            <BannerMedia display={{
          base: 'block',
          tablet: 'none'
        }} src={banner.mobileImageUrl} alt={banner.title} width={360} height={390} priority={index === 0} />
          </Carousel.Item>)}
      </Carousel.Content>

      <Flex position="absolute" bottom={4} left="50%" transform="translateX(-50%)" zIndex={1} data-sentry-element="Flex" data-sentry-source-file="BannerList.tsx">
        <Carousel.Dots gap={1.5} renderDot={props => <SliderDot {...props} />} data-sentry-element="Carousel.Dots" data-sentry-source-file="BannerList.tsx" />
      </Flex>
    </Carousel>;
};
export default BannerList;